import React from 'react';
import { Platform, StyleSheet, Text, View, } from 'react-native';
import { ColorTokens, IconTokens, BottomBarDLSType, TypographyTypeDLS, ButtonTypeDLS, DividerSizeTokens, } from '@voltmoney/schema';
import { Typography } from '../../typography/Typography';
import { addCommasToNumber, } from '../utils';
import { Icon } from '../../icon/Icon';
import { isMobileView, } from '../../stack/utils';
import BoilerPlate from '../boilerPlate/BoilerPlate';
import BottomBar from '../../bottomBarDLS/bottomBarDLS';
import CustomHeader from '../../customHeader/CustomHeader';
import Divider from '../../divider/Divider';
// import LottieView from "lottie-react-native";
const InterestRepaymentLearnMore = ({ height, interestRepaymentData, triggerAction, backAction, contactSupportAction, isFromTata, type, }) => {
    console.warn("INTEREST REPAYMENT RESPONSE", interestRepaymentData);
    let hearBreachDate = isFromTata ? '8th' : '14th';
    let softBreachDate = isFromTata ? '4th' : '7th';
    const header = () => {
        return (React.createElement(React.Fragment, null,
            React.createElement(CustomHeader, { title: '', triggerAction: triggerAction, goBackAction: backAction, needHelpAction: contactSupportAction })));
    };
    const body = () => {
        return (React.createElement(View, { style: styles.bodyContainer },
            React.createElement(Typography, { typeDLS: TypographyTypeDLS.H4S, label: 'What happens if your account is overdue?' }),
            React.createElement(View, { style: {
                    flexDirection: 'row',
                    marginTop: 16,
                } },
                React.createElement(View, { style: styles.circle },
                    React.createElement(Icon, { name: IconTokens.HEAD_SNAPSHOT, color: ColorTokens.Primary_100 })),
                React.createElement(View, { style: { marginLeft: 12 } },
                    React.createElement(Typography, { typeDLS: TypographyTypeDLS.B1M, label: `Penal interest ${isFromTata ? '@36%' : '@24%'} pa on ₹${addCommasToNumber(interestRepaymentData.totalAmount)}` }),
                    React.createElement(Text, null,
                        React.createElement(Typography, { typeDLS: TypographyTypeDLS.B2R, label: isMobileView() ? `Penal interest will be applied on amount overdue from \n${softBreachDate} of the month till payment date` : `Penal interest will be applied on amount overdue from \n${softBreachDate} of the month till payment date`, color: ColorTokens.Grey_Charcoal }))),
                React.createElement(Divider, { size: DividerSizeTokens.SM, color: ColorTokens.Grey_Milk })),
            React.createElement(View, { style: {
                    height: 1,
                    backgroundColor: '#F1F3F5',
                    width: '100%',
                    marginTop: 16,
                } }),
            React.createElement(View, { style: {
                    flexDirection: 'row',
                    marginTop: 16,
                } },
                React.createElement(View, { style: styles.circle },
                    React.createElement(Icon, { name: IconTokens.WORK_ALERT, color: ColorTokens.Primary_100 })),
                React.createElement(View, { style: { marginLeft: 12 } },
                    React.createElement(Typography, { typeDLS: TypographyTypeDLS.B1M, label: 'Portfolio sell-off to recover overdue amount' }),
                    React.createElement(Typography, { typeDLS: TypographyTypeDLS.B2R, label: isMobileView() ? `If payment is not done by ${hearBreachDate} of the month, portfolio\nsell-off will be done to recover overdue amount` : `If payment is not done by ${hearBreachDate} of the month, portfolio sell-off will\nbe done to recover overdue amount`, color: ColorTokens.Grey_Charcoal })),
                React.createElement(Divider, { size: DividerSizeTokens.SM, color: ColorTokens.Grey_Milk })),
            React.createElement(View, { style: {
                    height: 1,
                    backgroundColor: '#F1F3F5',
                    width: '100%',
                    marginTop: 16,
                } }),
            React.createElement(View, { style: {
                    flexDirection: 'row',
                    marginTop: 16,
                } },
                React.createElement(View, { style: styles.circle },
                    React.createElement(Icon, { name: IconTokens.SYSTEM_RUPEE_DLS, color: ColorTokens.Primary_100 })),
                React.createElement(View, { style: { marginLeft: 12 } },
                    React.createElement(Typography, { typeDLS: TypographyTypeDLS.B1M, label: 'Impact on credit score' }),
                    React.createElement(Typography, { typeDLS: TypographyTypeDLS.B2R, label: isMobileView() ? 'Not making payments on time can affect your\ncredit score' : 'Not making payments on time can affect your credit score', color: ColorTokens.Grey_Charcoal })))));
    };
    const footer = () => {
        return (React.createElement(BottomBar, { typeDLS: BottomBarDLSType.TYPE_A, btnLabel: 'Ok, got it!', onPress: () => {
                if (backAction) {
                    triggerAction(backAction);
                }
            }, btnTypeDLS: ButtonTypeDLS.PRIMARY, isPositionAbsolute: false }));
    };
    return (React.createElement(BoilerPlate, { height: height, headerChild: React.createElement(React.Fragment, null, header()), bottomChildren: React.createElement(React.Fragment, null, footer()) },
        React.createElement(React.Fragment, null, body())));
};
const styles = StyleSheet.create({
    container: {
        marginHorizontal: -16,
    },
    bodyContainer: {
        justifyContent: 'center',
        width: '100%',
        flexDirection: 'column',
        flex: 1,
        padding: 16
    },
    overlay: {
        ...StyleSheet.absoluteFillObject,
        justifyContent: 'center',
        alignItems: 'center',
        width: '100%',
        height: '100%',
    },
    circle: {
        width: 40,
        height: 40,
        borderRadius: 20,
        backgroundColor: '#F3F5FC',
        justifyContent: 'center',
        alignItems: 'center',
    },
    headerStyle: {
        ...(Platform.OS === 'ios' && {
            marginTop: 24,
        }),
    },
    successCard: {
        alignItems: 'center',
        flex: 1,
        height: 260,
        padding: 16,
    },
    successLottie: { width: 70, height: 'auto' },
    halfCardTitle: { marginTop: 16 },
    halfCardDescription: { marginTop: 4 },
    successCTA: {
        marginTop: 24,
        position: 'absolute',
        bottom: 0,
        marginBottom: 16,
        width: '94%'
    },
    bottomNoteContainer: {
        backgroundColor: '#FDF7E7',
        flexDirection: 'row',
        padding: 12,
        borderBottomRightRadius: 12,
        borderTopWidth: 1,
        borderColor: '#E4E7EC',
        borderBottomLeftRadius: 12,
        justifyContent: 'flex-start',
    },
    modalView: {
        justifyContent: 'flex-end',
    },
    contentContainer: {
        paddingHorizontal: 16,
        flex: 1,
    },
    failureCard: {
        alignItems: 'center',
        flex: 1,
        height: 270,
        padding: 16,
        justifyContent: 'space-between',
    },
    userCancelledCard: {
        alignItems: 'center',
        flex: 1,
        height: 260,
        padding: 16,
        justifyContent: 'space-between',
    },
    whyAutoPay: {
        flex: 1,
        padding: 16,
        justifyContent: 'space-between',
    },
    whyAutoPayDesc: { marginTop: -24 },
    whyAutoPayCTA: {
        width: '100%',
        alignItems: 'center',
        alignContent: 'center',
        alignSelf: 'center',
        justifyContent: 'flex-end',
    },
    errorCTA: {
        width: '100%',
        marginTop: 16,
        flexDirection: 'column',
    },
    landingTitle: {
        marginTop: 24,
        marginBottom: 16,
    },
    bankDetailsCard: {
        paddingTop: 16,
        paddingLeft: 16,
        paddingRight: 16,
        paddingBottom: 12,
    },
    accountDetails: {
        flexDirection: 'row',
        justifyContent: 'space-between',
    },
    accountContent: {
        width: 180,
        flexDirection: 'column',
    },
    autoDebitCard: {
        flexDirection: 'row',
        justifyContent: 'space-between',
        padding: 16,
    },
    mandateInfoImage: { marginTop: 2 },
    lineStyle: {
        borderWidth: 0.1,
        borderColor: '#E4E7EC',
    },
    bankCardContainer: {
        width: '100%',
        borderWidth: 1,
        borderRadius: 12,
        borderColor: '#E4E7EC',
        flexDirection: 'column',
        alignSelf: 'center',
    },
});
// @ts-ignore
export default InterestRepaymentLearnMore;
